var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChitChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14355 10.9464V26.375C5.14355 27.7951 6.29491 28.9464 7.71498 28.9464H27.2193C27.9026 28.9464 28.5577 29.2177 29.0411 29.7011L34.9033 35.5634C35.3083 35.9684 36.0007 35.6816 36.0007 35.1089V10.9464C36.0007 9.52636 34.8493 8.375 33.4293 8.375H7.71498C6.29491 8.375 5.14355 9.52636 5.14355 10.9464Z",
    fill: "#FFE67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 3.23158V18.6602C30.8571 20.0802 29.7058 21.2316 28.2857 21.2316H8.77821C8.09743 21.2316 7.44429 21.5022 6.96214 21.9837L1.09736 27.8485C0.692357 28.2535 0 27.9668 0 27.394V3.23158C0 1.81151 1.15136 0.660156 2.57143 0.660156H28.2857C29.7058 0.660156 30.8571 1.81151 30.8571 3.23158Z",
    fill: "#597BF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71498 13.5179C9.13514 13.5179 10.2864 12.3666 10.2864 10.9464C10.2864 9.52627 9.13514 8.375 7.71498 8.375C6.29482 8.375 5.14355 9.52627 5.14355 10.9464C5.14355 12.3666 6.29482 13.5179 7.71498 13.5179Z",
    fill: "#FFF0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4289 13.5179C16.849 13.5179 18.0003 12.3666 18.0003 10.9464C18.0003 9.52627 16.849 8.375 15.4289 8.375C14.0087 8.375 12.8574 9.52627 12.8574 10.9464C12.8574 12.3666 14.0087 13.5179 15.4289 13.5179Z",
    fill: "#FFF0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1437 13.5179C24.5639 13.5179 25.7151 12.3666 25.7151 10.9464C25.7151 9.52627 24.5639 8.375 23.1437 8.375C21.7235 8.375 20.5723 9.52627 20.5723 10.9464C20.5723 12.3666 21.7235 13.5179 23.1437 13.5179Z",
    fill: "#FFF0B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_2383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.207031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChitChatIcon);
export default __webpack_public_path__ + "static/media/chit_chat_icon.39fe8a4124d5a9f0b9338ed5426dabb2.svg";
export { ForwardRef as ReactComponent };